import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { TaskListDTO } from '@nx-frontend/shared/types';

interface CopyTaskBoardParams {
  serviceUrl: string;
  boardId: string;
  targetBoardId: string;
  userId?: number;
  secret?: string;
  targetNoteGlobalId: string;
  targetWorkspaceId: string;
}

export async function copyTaskBoard({
  boardId,
  targetBoardId,
  serviceUrl,
  userId,
  secret,
  targetNoteGlobalId,
  targetWorkspaceId,
}: CopyTaskBoardParams): Promise<TaskListDTO> {
  const headers: Record<string, string> = {};
  if (secret) {
    headers['X-Secret'] = secret;
  }
  const requestBody = {
    from: boardId,
    to: targetBoardId,
    toNote: targetNoteGlobalId,
    toWorkspace: targetWorkspaceId,
  };
  console.log(requestBody);
  const response = await axiosClient.post<TaskListDTO>(`${assertServiceHost(serviceUrl)}/v1/boards/copy`, requestBody, {
    headers,
    userId,
    secret,
  });
  return response.data;
}
